import React from 'react'
import style from './demo.module.scss'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'

const Demo = () => {
	const { t } = useTranslation()

	return (
		<div
			className={cx(
				style.demo,
				 'animate__animated',
				 'animate__fadeInDown'
			)}
		>
			{t('demoMode')}
		</div>
	)
}

Demo.propTypes = {}

export { Demo }
